import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const geoKeys = {
	countries: ["geo", "countries"] as const,
	currencies: ["geo", "currencies"] as const,
};

export function useGeoCountries() {
	return useQuery({
		queryKey: geoKeys.countries,
		queryFn: () => api.geo.listCountries(),
	});
}

export function useGeoCurrencies() {
	return useQuery({
		queryKey: geoKeys.currencies,
		queryFn: () => api.geo.listCurrencies(),
	});
}
